// LUMINA · pages/vajra/admin/PaymentConfigSection.jsx
// Phase 39D: extracted from AdminHub.jsx — 支付渠道配置（site-config）

import React, { useState, useEffect, useCallback } from 'react';
import { API, GD, DG, CR, PANEL } from '../constants';

export default function PaymentConfigSection({ token, headers }) {
  const [payConfig, setPayConfig] = useState({payment_etransfer:"",payment_paypal:"",payment_wechat_id:"",payment_wechat_qr:""});
  const [payConfigMsg, setPayConfigMsg] = useState("");

  const loadPayConfig = useCallback(async () => {
    const pay = await fetch(`${API}/vajra/offerings/payment-info`).then(r=>r.ok?r.json():{}).catch(()=>({}));
    setPayConfig({
      payment_etransfer: pay.etransfer||"",
      payment_paypal: pay.paypal||"",
      payment_wechat_id: pay.wechat_id||"",
      payment_wechat_qr: pay.wechat_qr||"",
    });
  }, []);

  useEffect(() => { loadPayConfig(); }, [loadPayConfig]);

  return (
    <div style={{background:PANEL,borderRadius:12,padding:"20px",border:`1px solid rgba(0,0,0,0.06)`}}>
      <div style={{fontSize:15,color:GD,fontWeight:600,marginBottom:14}}>支付渠道配置</div>
      {payConfigMsg&&<div style={{fontSize:12,padding:"8px",borderRadius:6,marginBottom:10,background:payConfigMsg.startsWith("✓")?"rgba(6,78,59,0.06)":"rgba(107,26,26,0.06)",color:payConfigMsg.startsWith("✓")?DG:CR}}>{payConfigMsg}</div>}
      {[
        {key:"payment_etransfer",label:"E-Transfer 账号"},
        {key:"payment_paypal",   label:"PayPal 账号"},
        {key:"payment_wechat_id",label:"微信号"},
        {key:"payment_wechat_qr",label:"微信二维码 URL"},
      ].map(cfg=>(
        <div key={cfg.key} style={{marginBottom:12}}>
          <div style={{fontSize:11,color:"#aaa",marginBottom:4}}>{cfg.label}</div>
          <input value={payConfig[cfg.key]||""} onChange={e=>setPayConfig(p=>({...p,[cfg.key]:e.target.value}))}
            style={{width:"100%",padding:"9px 12px",border:"1px solid rgba(107,26,26,0.25)",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
        </div>
      ))}
      <button onClick={async()=>{
        const r=await fetch(`${API}/vajra/staff/site-config`,{method:"PUT",headers,body:JSON.stringify(payConfig)});
        if(r.ok)setPayConfigMsg("✓ 配置已保存");else setPayConfigMsg("✗ 保存失败");
      }} style={{padding:"10px 24px",background:GD,color:"#fff",border:"none",borderRadius:8,fontSize:13,cursor:"pointer"}}>
        保存配置
      </button>
    </div>
  );
}
